import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APITemplateService } from '../../_services/template/API-template';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { style } from '@angular/animations';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CryptoJS from 'crypto-js';
import { saveAs as importedSaveAs } from "file-saver";
import { Router, ActivatedRoute } from '@angular/router';    
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { VoiceService } from '../../_services/voice/voice';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({

  selector: 'app-voice-templates-by-pe',
  templateUrl: './voice-templates-by-pe.component.html',
  styleUrls: ['./voice-templates-by-pe.component.css']

})

export class VoiceTemplatesByPeComponent implements OnInit {

  maxDate: Date = new Date();

  deactvResult: any;
  fileDownload: any = [];
  newEntities: number[] = [];
  newSummaries: number[] = [];
  entity: any = [];
  data: any = {};

  entitySummary: any = [];
  modelTest: any;
  entityId: any;
  filterData: any;
  show: boolean = false;
  statusMongo: String;
  dataSource: MatTableDataSource<any>;
  dataSource1: MatTableDataSource<any>;
  dataSource2: MatTableDataSource<any>;
  noRecord: any;
  noRecord1: any;
  noRecord2: any;
  refNos = "";
  emailids = "";
  Entity_EmailID: any;
  
  Template_Status: any;
  showDropdown: boolean = false
  showStatusDropdown: boolean = false
  islink: boolean = true     
  public modalRef: BsModalRef;

  
  isValidDate: any;
  verifyTemplate: any = {};
  verifyTemplateKey: any = {};
  minLen: boolean = false;
  maxLen: boolean = false;
  specialChar: boolean = false;
 
  error: any = { isError: false, errorMessage: "" };
 
  disableread: boolean[] = [];
  prevURN: any = ''
  default: any = 'empty'

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;
  @ViewChild('t2Sort') t2Sort: MatSort;
  @ViewChild('t3Sort') t3Sort: MatSort;


  dataSubject = new BehaviorSubject<any[]>([]);

  displayedColumns: string[] = ['Template_Ref_No', 'Template_ID', 'Template_Header', 'Template_Name', 'Content_Type', 'Template_Variables', 'Template_CommunicationType', 'Template_Category', 'Template_Status', 'CSTempID', 'createdAt','justification', 'type_of_call','support_docs','modify','Suspension/Reactivation','Last_Action','Last_Action_date'];
  

  displayedColumns1: any[] = [ 'Template_Ref_No', 'Content_Type', 'Template_Header', 'Entity_ID', 'T_Created_Date', 'T_Updated_By', 'Template_Name',
    'Template_Content', 'Template_CommunicationType', 'Content_Type','support_docs','modify', 'Suspension/Reactivation','Template_Status','type_of_call','justification','Last_Action','Last_Action_date'];

  
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE);
  deactivate = [];
  headerlist: any = [];
  
  fetchedData: any;
  EntityDetails: any;
  industry_type: any;
  industry_category: any;
  sector: any;
  entity_name: any;
  temp_var: any;

  VerificationStsForm: FormGroup;
  VerificationReasonForm: FormGroup;
  reasonArray: any;
  ActionSource: any;



  getDisplayedColumns(): string[] {

    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns1
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);

    return a;
  }



  form1: any = {};
  form2: any = {};

  constructor(
    
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private vs: VoiceService,
    private modalService: BsModalService,
    private router: Router,
    private $: $BroadcastManagerService) { }

  ngOnInit() {
    
    this.getVoiceEntityDetails();
    this.APIgetVoiceTemplateSummary();


    

    this.modelTest = this.$modal;
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.Entity_EmailID = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
    this.maxDate.setDate(new Date().getDate());

    this.VerificationStsForm = this.fb.group({

      VerificationStsArray: this.fb.array([])
    })

     


    this.default = "empty"

    
    this.VerificationReasonForm = this.fb.group({
      VerificationReason: this.fb.array([])
    })
   
  }
  reset() {
    this.verifyTemplate = {};
    this.verifyTemplateKey = {};
    this.data['Entity_ID'] = this.entityId

    this.form1.searchBy1 = null
    this.APIgetVoiceTemplateSummary();
    this.showDropdown = false;
    this.showStatusDropdown = false;
    

  }

  showCSTinfo(name, content) {
    this.$modal.promptModal({
      title: "Consent Template Name: " + name,
      msg: "Consent Template Content: " + content
    });
  }



  openDropdown(value) {
    
    if (value == "Communication Type") {
      this.showDropdown = true;
      this.showStatusDropdown = false;
    }


    else if (value == "Status") {
      this.showStatusDropdown = true;
      this.showDropdown = false;
    }
    else {
      this.showDropdown = false;
      this.showStatusDropdown = false;
    }
    

  }

  listvalue(event) {
    if (event) {
      this.form1.searchBy = "Communication Type"
    }
  }



 

  
  download(file1, Refno) {

    var data = {
      "Container": "voicetemplates",
      "URN": "1607" + Refno,
      "FileName": file1
    }

    this.vs.voiceTempfiledownload(data).subscribe(r => {

      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Voice Templates File Download',
        msg: 'File has been downloaded Successfully'
      });
    })

  }


  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }



  onSubmitFilter(filterForm) {

    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";

    
    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy2)
      param = filterForm.searchBy2;

      console.log("filtertype--param----------", filterType,param);

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }
     
   


    this.data = {


      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
       "param":param
     
    }

    console.log("------data-----",this.data);
    
    
    if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Date Difference should not be more than 30 days'
      });
    }
   
    else {
      this.data['Entity_ID'] = this.entityId
      this.vs.VoiceTemplatepeFilter(this.data)
        .subscribe(r => {

          this.fetchedData = JSON.stringify(r.Data);
          this.dataSource = r.Data;
          this.onChangeDataSource(r.Data);
        });
    }
  }


  

  
  get h() { return this.VerificationReasonForm.controls; }


  onKey(event: any, urn: any, vars: any, j: any) {
    
    if (event.target.value !== "") {
      this.verifyTemplateKey["urn"] = urn;
      this.verifyTemplateKey["reason"] = event.target.value
      this.verifyTemplateKey["vars"] = vars;
    }

    if (parseInt(vars) > 2) {
      
      this.VerificationReasonForm.controls.VerificationReason.get(j.toString()).setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(100), Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)])
      this.VerificationReasonForm.controls.VerificationReason.get(j.toString()).updateValueAndValidity()

    }
   

  }



  linkFn(CSTempID, commtype, Refno) {

    if (CSTempID != "")
      this.islink = false
    else
      this.islink = true

    var str1 = new String("1607");
    var str2 = new String(Refno);
    var TempID = str1.concat(str2.toString());

    this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.entityId);
    this.db.set(Constants.SESSSION_STORAGE, Constants.CONSENTTEMPLATEID, CSTempID);
    this.db.set(Constants.SESSSION_STORAGE, Constants.MODEOFCOMMUNICATION, commtype);
    this.db.set(Constants.SESSSION_STORAGE, Constants.TM_ID, TempID);
    this.db.set(Constants.SESSSION_STORAGE, Constants.CSTLINKDELINK, this.islink);

    this.router.navigate(['linking_consent']);
  }

 
  APIgetVoiceTemplateSummary() {
    let eId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    var query = {
      "Template_Status": { $in:  ["A", "R", "B", "C", "PP", "FT", "SC", "SV" ] },
      Entity_ID: eId,
    }
    console.log("api get voice template")
    
    this.vs.getVoicepeTemplateSummaryMongo(query)
      .subscribe(r => {
        console.log("summary ----------------  ", r)
        this.entity = r;
        console.log("summary1 ----------------  ", r) 
        this.onChangeDataSource(this.entity);
        if (r.message == "success") {
          this.$modal.successModal({
            title: 'Entity Registration',
            msg: 'Entity has been Approved'
          });
        }
      });

  }



  onChangeDataSource(value) {
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }



  downloadTemplates(filterForm) {

    

    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (filterForm.searchBy1)
      filterType = filterForm.searchBy1;
    if (filterForm.searchBy2)
      filterType = filterForm.searchBy2;

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    


    if (fdate != "" && ldate == "") {
      ldate = cdate
    }




    if ((filterType == "URN" || filterType == "Template Name" || filterType == "Header") && !param)
      alert("Please enter Search Parameter")
    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      alert("Date Difference should not be more than 30 days")
    }

    else if (fdate > ldate) {
      alert("From Date cannot be after To Date")
    }

    else if (fdate == "" && ldate != "") {
      alert("Please select Start date")
    }


    else {


      var fileName;
      const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
      this.data['Entity_ID'] = this.entityId
      

      this.vs.downloadvoiceTemplatesbyPE(this.data).subscribe(r => {
        fileName = currentdat + ' Templates.csv';
        console.log("--------------r------",r)
        importedSaveAs(r, fileName)
        this.$modal.successModal({
          title: 'Voice Templates',
          msg: 'File has been downloaded Successfully'
        });
      })
    }
  }


  getVoiceEntityDetails() {
    let data = {
      "entity_id": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
    }
    console.log("get voice entity detail" , data)
    this.vs.getVoiceContentEntityDetailsbyPE(data)
      .subscribe(r => {
        try {
  
       console.log("  r ", r)
          if (r[0].etype === 'P') {
            this.industry_type = "Private";

          }
          else if (r[0].etype == 'G') {
            this.industry_type = "Government";
          }
          else if (r[0].etype == 'S') {
            this.industry_type = "SEBI";
          }
          else if (r[0].etype == 'O') {
            this.industry_type = "Others";
          }
          else if (r[0].etype == 'U') {
            this.industry_type = "Unknown";
          }
          this.entity_name = r[0].name

        }
        catch (e) {
          console.log("error", e)

        }
      })
  }


  


  modalwithradio(final: any) {
    console.log("-----------input element--------", final)
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.voiceModalDataObj = {
      title: "Voice Template",
      msg: "Do you like to suspend the Template Temporarily or Permanently",
      showRadioButton: true,
      radioOptions: ["Temporary", "Permanent"],
    };
    this.modalRef.content.onClose.subscribe((result) => {
      if (result == true) {
        const selectedOption = this.modalRef.content.selectedOption;
        let remarks = this.modalRef.content.remarks;
        let VoiceTemp_Status;
        if (selectedOption === "Permanent") {
          VoiceTemp_Status = "B";
        } else if (selectedOption === "Temporary") {
          VoiceTemp_Status= "SC";
        }

        let datavalue = {
          VoiceTemp_Ref_No: final.VoiceTemp_Ref_No,
        
          Entity_ID: this.db.get(
            Constants.SESSSION_STORAGE,
            Constants.ENTITY_ID
          ),
          VoiceTemp_Status:VoiceTemp_Status,
          selectedOption: selectedOption,
          remarks:remarks,
          //retactivaion we need to include remakrs
          eclass:"PE"
        };
        console.log("----------datavalue----", datavalue);

        this.vs.GetActionbype(datavalue).subscribe((r) => {
          if (r.status == "success") {
           
            this.reset();
            console.log("---data---", this.data);

            this.$modal.successModal({
              title: "Voice Template Suspension/ Revocation",
              msg: "Voice Template has been suspended successfully",
             
            });
          } else {
            this.$modal.errorModal({
              title: "Voice Template Suspension/ Revocation",
              msg: r.msg,
              
            });
          }
        });
        
      }
    });
  }






  reactivatefn(final) {
    console.log("----reactivate----");
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Voice Template Reactivation",
      msg: "Are you sure you want to Reactivate the Voice Template",
    }
    this.modalRef.content.onClose.subscribe(result => {
      if (result === true) {
        let datavalue = {
          VoiceTemp_Ref_No: final.VoiceTemp_Ref_No,
         
          Entity_ID: this.db.get(
            Constants.SESSSION_STORAGE,
            Constants.ENTITY_ID
          ),
          VoiceTemp_Status: "A",
          eclass:"PE",
          remarks: this.modalRef.content.remarks,
        };
        console.log("----------datavalue----", datavalue);
        this.vs.GetActionbype(datavalue).subscribe((r) => {
          if (r.status == "success") {
          
            this.reset();
            console.log("---data---", this.data);
            this.$modal.successModal({
              title: "Voice Template Reactivation",
              msg: "Voice Template has been Reactivated successfully",
              
            });
          } else {
            this.$modal.errorModal({
              title: "Voice Template Reactivation",
              msg: r.msg,
             
            });
          }
        });
      }
    })
  }



}





export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}
